module.exports = __webpack_public_path__ + "02_veryshort_beige.dce28085.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_veryshort_beige.png
// module id = xg2q
// module chunks = 0